import { resolveApiBaseUrl } from '@minibook/shared';
import { initOnboardingTrace, traceOnboardingErrorTail } from '@minibook/shared/client/onboardingTrace';
import { ensureRegistrationFlowId, getOrCreateClientId } from './registrationTracking';
import { getMasterId } from '../auth/tokenStorage';

const build = `web-master@${import.meta.env.VITE_GIT_COMMIT || import.meta.env.MODE || 'dev'}`;

export function bootstrapOnboardingTrace(): void {
  if (typeof window === 'undefined') return;
  initOnboardingTrace({
    getApiBaseUrl: () =>
      resolveApiBaseUrl({
        apiBaseUrl: import.meta.env.VITE_API_BASE_URL,
        apiUrl: import.meta.env.VITE_API_URL,
      }).replace(/\/$/, ''),
    app: 'web-master',
    getBuild: () => build,
    getUserId: () => {
      const id = getMasterId();
      return id ? `usr_${id}` : null;
    },
    getAnonId: () => {
      const c = getOrCreateClientId();
      return c.startsWith('cli_') ? `an_${c.slice(4)}` : `an_${c}`;
    },
    getFlowId: () => ensureRegistrationFlowId(),
  });

  window.addEventListener('error', (ev) => {
    const msg = ev.error?.message || ev.message;
    if (/Loading chunk|ChunkLoadError/i.test(msg)) return;
    void traceOnboardingErrorTail({
      event: 'frontend_error',
      result: 'error',
      screen: 'global',
      step: 'window_error',
      error: msg,
      payload: { filename: ev.filename, lineno: ev.lineno, colno: ev.colno },
    });
  });

}
